import React, { Component, createRef } from "react";
import layers_icon from "../../assets/images/layers_icon.png";
import "./Header.scss";
import SearchIcon from "@material-ui/icons/Search";
import go_to_icon from "../../assets/images/go_to_icon.png";
import {
  AddressInfo,
  SearchOption,
  LanguageOption,
  Coordinates,
} from "../../entities/iconData";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { BrowserLanguage } from "../../entities/BrowserLanguage";
import location_icon from "../../assets/images/location_icon.png";
import israel_icon from "../../assets/images/israel.png";
import russia_icon from "../../assets/images/russia.png";
import united_arab_icon from "../../assets/images/united-arab.png";
import united_states_icon from "../../assets/images/united-states.png";
import language_icon from "../../assets/images/language.svg";
import Select, { components } from "react-select";
import station_1_icon from "../../assets/images/station_1_icon.png";
import station_2_icon from "../../assets/images/station_2_icon.png";
import busy_station_icon from "../../assets/images/busy_station_icon.png";
import inactive_station_icon from "../../assets/images/inactive_station_icon.png";
import comingSoon_station_icon from "../../assets/images/comingSoon_station_icon.png";
import { LayersFilters } from "../../entities/LayersFilters";
import filter_icon from "../../assets/images/filter_icon.png";
import { StringsData } from "../../entities/StringsData";
import { slide as Menu } from "react-burger-menu";
import Popup from "../Popup/Popup";
import contact_us_icon from "../../assets/images/contact_us_icon.png";
import gmap from "../../assets/images/google-maps-icon.svg.png";
import { PopupType } from "../../entities/PopupType";
import { Icon, Popper } from "@material-ui/core";
import { kMaxLength } from "buffer";

class Header extends Component<HeaderProps, HeaderState> {
  languageSelectRef = createRef<any>();

  getLanguageButtonLabel = () => {
    const { browserLanguage } = this.props;

    switch (browserLanguage) {
      case BrowserLanguage.he:
        return "בחירת שפה, ניתן ללחיצה";
      case BrowserLanguage.ar:
        return "اختيار اللغة، يمكن الضغط";
      case BrowserLanguage.ru:
        return "Выбор языка, кнопка";
      case BrowserLanguage.en:
      default:
        return "Language selection, clickable button";
    }
  };

  constructor(props: HeaderProps) {
    super(props);
    this.state = {
      openMenuBar: false,
      openPopup: false,
      popupType: PopupType.EMPTY,
      portalView: false,
      languageMenuOpen: false, // controls the react-select dropdown open state
    };
  }

  componentDidMount = () => {
    const portal = window.location.search.includes("portal");
    this.setState({ portalView: portal });
  };

  componentDidUpdate(prevProps: HeaderProps, prevState: HeaderState) {
    // When the language menu has just been opened, focus on the react-select input
    if (!prevState.languageMenuOpen && this.state.languageMenuOpen) {
      if (
        this.languageSelectRef &&
        this.languageSelectRef.current &&
        this.languageSelectRef.current.focus
      ) {
        // this.languageSelectRef.current.focus();
      }
    }
  }

  // Toggle the language dropdown state
  toggleLanguageMenu = () => {
    this.setState((prevState) => ({
      languageMenuOpen: !prevState.languageMenuOpen,
    }));
  };

  // Listen for keyboard events on the parent container and toggle dropdown on Enter
  handleLanguageKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter") {
      this.toggleLanguageMenu();
    }
  };

  render() {
    const {
      browserLanguage,
      stringsFromServer,
      closeAllPopupsFunc,
      setSelectedStationCoordinates,
    } = this.props;
    const direction =
      browserLanguage === "ar" || browserLanguage === "he" ? "rtl" : "ltr";
    return (
      <header className={`header-page ${browserLanguage}`}>
        {!this.state.portalView && (
          <div className={`title-header ${browserLanguage} desktop-only`}>
            <img
              className={`title-header-img ${browserLanguage}`}
              src={station_1_icon}
              alt="staion icon"
            />
            <span className={`title-header-text ${browserLanguage}`}>
              {stringsFromServer.site_MainHeader}
            </span>
          </div>
        )}
        {/*
        <div className={`layers ${browserLanguage}`}
          onClick={() => this.props.layersPopup()}
        >
          <img src={layers_icon} alt="layers icon" />
        </div>
        */}
        <div className={`language-search ${browserLanguage} desktop-only`}>
          <div className={`search ${browserLanguage}`}>
            <Autocomplete
              id="combo-box-demo"
              fullWidth={true}
              forcePopupIcon={false}
              PopperComponent={(props: any) => (
                <Popper
                  {...props}
                  style={{ width: "23vw", direction: direction }}
                />
              )}
              style={{ direction: direction }}
              options={this.searchStations()}
              getOptionLabel={(option: SearchOption) =>
                option.name + " - " + option.address
              }
              onChange={(event: any, newValue: SearchOption | null) =>
                this.props.setSelectedStationCoordinates(newValue)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  style={{ width: "23vw", direction: direction }}
                  label={
                    <div className={`label-search-text ${browserLanguage}`}>
                      <SearchIcon /> {stringsFromServer.site_SearchText}
                    </div>
                  }
                  variant="outlined"
                  size="small"
                ></TextField>
              )}
              renderOption={(option: SearchOption) => (
                <div>
                  <div className="select-station-div">
                    <span className="select-name-img">
                      <img
                        src={this.getCorrectStationIcon(option.status)}
                        alt="station icon"
                      ></img>
                      {option.name}
                      {option.address ? " - " + option.address : " "}
                    </span>
                    <div className={`distance-from-user ${browserLanguage}`}>
                      {" "}
                      {this.getStringDistance(option.distanceFromUser)}{" "}
                    </div>
                  </div>
                </div>
              )}
            />
          </div>
        </div>
        {/*
          Desktop language select wrapped in a focusable div so that Enter toggles the dropdown.
          We call languageSelect(true) here to attach the ref.
        */}
        <div
          tabIndex={0}
          role="combobox"
          aria-label={this.getLanguageButtonLabel()}
          aria-haspopup="listbox"
          aria-expanded={this.state.languageMenuOpen}
          onClick={(e) => {
            this.languageSelectRef?.current?.focus();
            this.toggleLanguageMenu();
          }}
          // onClick={(e) => this.toggleLanguageMenu()}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              this.languageSelectRef?.current?.focus();
              this.toggleLanguageMenu();
            }
          }}
          className={`language-select desktop-only ${browserLanguage}`}
        >
          <img
            className="language-icon"
            src={language_icon}
            alt="בחירת שפה"
            aria-label="בחירת שפה"
            // aria-hidden="true"
            onClick={this.toggleLanguageMenu}
          />
          {this.languageSelect(true)}
        </div>

        <div className="mobile-mode header-mobile">
          {this.getPopupTitleFilter()}
          <div className={`title-header ${browserLanguage} mobile-mode`}>
            <img
              className={`title-header-img ${browserLanguage}`}
              src={station_1_icon}
              alt="staion icon"
            />
            <span className={`title-header-text ${browserLanguage}`}>
              {stringsFromServer.site_MainHeader}
            </span>
          </div>
          <div className={`side-bar ${browserLanguage}`}>
            <div
              className={
                this.props.openMenuBar
                  ? "humburger humburger-open"
                  : "humburger"
              }
              onClick={() => {
                this.props.toggleMenuBar();
                this.props.closeAllPopupsFunc();
              }}
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
            {this.props.openMenuBar ? (
              <div className={`menu-side-bar ${browserLanguage}`}>
                <div className={`search ${browserLanguage}`}>
                  <Autocomplete
                    id="combo-box-demo"
                    forcePopupIcon={false}
                    fullWidth={true}
                    PopperComponent={(props: any) => (
                      <Popper
                        {...props}
                        style={{ width: "300px", direction: direction }}
                      />
                    )}
                    options={this.searchStations()}
                    getOptionLabel={(option: SearchOption) =>
                      option.name + " - " + option.address
                    }
                    onChange={(event: any, newValue: SearchOption | null) => {
                      this.setState({ openMenuBar: false });
                      setSelectedStationCoordinates(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          <div
                            className={`label-search-text ${browserLanguage}`}
                          >
                            <SearchIcon /> {stringsFromServer.site_SearchText}
                          </div>
                        }
                        variant="outlined"
                        size="small"
                      ></TextField>
                    )}
                    renderOption={(option: SearchOption) => (
                      <div>
                        <div className="select-station-div">
                          <span className="select-name-img">
                            <img
                              src={this.getCorrectStationIcon(option.status)}
                              alt="station icon"
                            ></img>
                            {option.name}
                            {option.address ? " - " + option.address : " "}
                          </span>
                          <div
                            className={`distance-from-user ${browserLanguage}`}
                          >
                            {" "}
                            {this.getStringDistance(
                              option.distanceFromUser
                            )}{" "}
                          </div>
                        </div>
                        <div className="Navgo-to">
                          <img
                            alt="gmap"
                            src={gmap}
                            onClick={() => this.googleMapsNavigation(option)}
                          />
                          <span className={`Navlabel ${browserLanguage}`}>
                            {" "}
                            {stringsFromServer.site_StationInfoNavigate}{" "}
                          </span>
                        </div>
                      </div>
                    )}
                  />
                </div>
                {/*
                  Mobile language select – no need for the ref here.
                */}
                <div
                  className={`language-select ${browserLanguage}`}
                  onClick={this.toggleLanguageMenu}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      this.toggleLanguageMenu();
                    }
                  }}
                  role="button"
                  tabIndex={0}
                  aria-label={"בחירת שפה"}
                >
                  <img src={language_icon} alt="בחירת שפה" aria-hidden="true" />
                  {this.languageSelect(false)}
                </div>

                <div className="center">
                  <a
                    className="terms"
                    onClick={() => this.openPopup(PopupType.TERMS_OF_USE)}
                  >
                    <span className="footer-text">
                      {" "}
                      {stringsFromServer.site_TermsOfUse}
                    </span>
                  </a>
                  <div
                    className="accessibillty"
                    onClick={() =>
                      this.openPopup(PopupType.ACCESSIBILITY_STATMENT)
                    }
                  >
                    <span className="footer-text">
                      {stringsFromServer.site_AccessbillityText}
                    </span>
                  </div>
                  <div
                    className={`contact-us ${browserLanguage}`}
                    onClick={() => this.openPopup(PopupType.POPUP_CONTACT)}
                  >
                    <span className="footer-text">
                      {" "}
                      {stringsFromServer.site_ContactText}
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <div className={`not-show-menu-bar ${browserLanguage}`}></div>
            )}
          </div>
          {this.state.openPopup && (
            <Popup
              stringsFromServer={stringsFromServer}
              openPopup={this.state.openPopup}
              closePopup={this.closePopup}
              popupType={this.state.popupType}
              browserLanguage={browserLanguage}
            ></Popup>
          )}
        </div>
      </header>
    );
  }

  getStringDistance = (distance: number) => {
    const KM = this.props.browserLanguage === "he" ? 'ק"מ' : "Km";
    if (!distance) return "";
    if (distance < 1) {
      return distance.toString().slice(0, 4) + " " + KM;
    }
    return " " + Math.floor(distance) + " " + KM;
  };

  /**
   * languageSelect accepts a parameter attachRef.
   * If attachRef is true, we attach a ref to the Select component so that we can call .focus()
   * on it when the dropdown is opened via keyboard.
   */
  languageSelect = (attachRef: boolean = false) => {
    const options: LanguageOption[] = [
      { value: BrowserLanguage.he, label: "עברית" },
      { value: BrowserLanguage.en, label: "English" },
      { value: BrowserLanguage.ar, label: "عربي" },
      { value: BrowserLanguage.ru, label: "русский" },
    ];

    document.documentElement.lang = this.props.browserLanguage;

    const { Option } = components;
    const IconOption = (props: any) => (
      <Option {...props}>{props.data.label}</Option>
    );

    const isRtl =
      this.props.browserLanguage === "he" ||
      this.props.browserLanguage === "ar";

    const customStyles = {
      control: (base: any) => ({
        ...base,
        border: 0,
        boxShadow: "none",
        cursor: "pointer",
        direction: "rtl",
        backgroundColor: "transparent",
      }),
      menu: (base: any) => ({
        ...base,
        direction: isRtl ? "rtl" : "ltr",
        textAlign: isRtl ? "right" : "left",
      }),
      singleValue: (base: any) => ({
        ...base,
        direction: "ltr",
        textAlign: "left",
        color: "#000",
      }),
      option: (base: any) => ({
        ...base,
        direction: isRtl ? "rtl" : "ltr",
        textAlign: isRtl ? "right" : "left",
      }),
    };

    return (
      <div
        role="combobox"
        aria-haspopup="listbox"
        aria-expanded={this.state.languageMenuOpen}
      >
        <Select
          ref={attachRef ? this.languageSelectRef : null}
          classNamePrefix="Select"
          className={`Select ${this.props.browserLanguage}`}
          styles={customStyles}
          defaultValue={options.find(
            (opt) => opt.value === this.props.browserLanguage
          )}
          options={options}
          components={{ IndicatorSeparator: () => null, Option: IconOption }}
          onChange={(languageOption: any) => {
            this.handleChangeLanguage(languageOption.value);
            this.setState({ languageMenuOpen: false });
          }}
          isSearchable={false}
          menuIsOpen={this.state.languageMenuOpen}
          // tabIndex={}
          aria-label="בחר שפה"
          aria-live="off"
          // screenReaderStatus={() => ""}
          autoFocus={false}
          // screenReaderInstructions={() => ""}
          ariaLiveMessages={{
            onFocus: (option) => option.label,
          }}
        />
      </div>
    );
  };

  getCorrectStationIcon(status: number): string {
    switch (status) {
      case LayersFilters.AVAILABLE:
        return station_2_icon;
      case LayersFilters.BUSY:
        return busy_station_icon;
      case LayersFilters.INACTIVE:
        return inactive_station_icon;
      case LayersFilters.COMING_SOON:
        return comingSoon_station_icon;
      default:
        return station_2_icon;
    }
  }

  searchStations = (): SearchOption[] => {
    const criteriaSearchArr = this.props.addressInfoData.map(
      (addressInfo: AddressInfo) => {
        const searchOption = {
          name: addressInfo.name ? addressInfo.name : "",
          address: addressInfo.streetName,
          id: addressInfo.id,
          status: addressInfo.status,
          connectorTypesArr: addressInfo.moreInfoStationData
            ? addressInfo.moreInfoStationData.connectorTypesArr
            : [],
          distanceFromUser: addressInfo.distanceFromUser,
        };
        return searchOption;
      }
    );
    return criteriaSearchArr.sort(
      (a, b) => a.distanceFromUser - b.distanceFromUser
    );
  };

  wazeNavigation = (searchOpt: SearchOption) => {
    let addressInfo = this.props.addressInfoData.filter(
      (adrr) => adrr.id === searchOpt.id
    );
    const wazeBaseUrl = "https://www.waze.com/";
    const wazeLanguage = this.getWazeLanguage();
    const wazeTo = "to=ll." + addressInfo[0].lat + "%2C" + addressInfo[0].lng;
    const wazeFrom = !this.props.userLocation
      ? ""
      : "&from=ll." +
        this.props.userLocation.lat +
        "%2C" +
        this.props.userLocation.lng;
    const wazeURL =
      wazeBaseUrl + wazeLanguage + "live-map/directions?" + wazeTo + wazeFrom;
    window.open(wazeURL, "_blank");
  };

  getWazeLanguage(): string {
    switch (this.props.browserLanguage) {
      case "ru":
      case "ar":
      case "he": {
        return this.props.browserLanguage + "/";
      }
      case "en-US":
      default: {
        return "";
      }
    }
  }

  googleMapsNavigation = (searchOpt: SearchOption) => {
    let addressInfo = this.props.addressInfoData.filter(
      (adrr) => adrr.id === searchOpt.id
    );
    const googleMapsUrl =
      "https://www.google.com/maps/?q=" +
      addressInfo[0].lat +
      "," +
      addressInfo[0].lng;
    window.open(googleMapsUrl, "_blank");
  };

  handleChangeLanguage = (newLanguage: string) => {
    console.log("newLanguage", newLanguage);
    this.props.changeLanguage(newLanguage);
  };

  getPopupTitleFilter = () => {
    return (
      <div
        className={`title-filter-mobile mobile-mode ${this.props.browserLanguage}`}
        onClick={() => {
          this.props.filterPopup();
        }}
      >
        <span className="title-img">
          <img src={filter_icon} alt="filter icon" />
        </span>
      </div>
    );
  };

  openPopup = (popupType: PopupType) => {
    this.setState({ openPopup: true, popupType });
    this.props.closeAllPopupsFunc();
  };

  closePopup = () => {
    this.setState({ openPopup: false });
  };
}

interface HeaderProps {
  browserLanguage: BrowserLanguage;
  addressInfoData: AddressInfo[];
  setSelectedStationCoordinates: Function;
  filterPopup: Function;
  layersPopup: Function;
  changeLanguage: Function;
  stringsFromServer: StringsData;
  closeAllPopupsFunc: Function;
  userLocation?: Coordinates;
  toggleMenuBar: () => void;
  openMenuBar: boolean;
}

interface HeaderState {
  openMenuBar: boolean;
  openPopup: boolean;
  popupType: PopupType;
  portalView: boolean;
  languageMenuOpen: boolean;
}

export default Header;
